<!-- PAGE HEADER -->
<div class="page-header filter-card">
  <div class="page-header-left">
    <!-- <div class="page-header-icon">🔔</div> -->
    <div>
      <div class="page-header-title">Push Notifications</div>
      <div class="page-header-sub">
        Manage and schedule push notification campaigns
      </div>
    </div>
  </div>

  <div class="page-header-right">
    <!-- <div class="badge-total">{{ totalDataCount }} Total Records</div> -->
    <button nz-button nzType="primary" (click)="navigateToAdd()">
      <i nz-icon nzType="plus"></i> Add Notification
    </button>
  </div>
</div>

<!-- FILTER CARD -->
<div class="filter-card">
  <div class="filter-card-header">Filters</div>

  <div nz-row [nzGutter]="[16, 16]">
    <!-- Type -->
    <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">Type</div>
        <nz-select
          class="width-100"
          nzAllowClear
          nzPlaceHolder="Select Type"
          [(ngModel)]="selectedType"
          (ngModelChange)="onFilterChange()"
        >
          <nz-option nzLabel="General" nzValue="general"></nz-option>
          <nz-option nzLabel="User" nzValue="user"></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Status -->
    <!-- <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">🔘 Status</div>
        <nz-select
          class="width-100"
          nzAllowClear
          nzPlaceHolder="Select Status"
          [(ngModel)]="selectedStatus"
          (ngModelChange)="onFilterChange()"
        >
          <nz-option nzLabel="Active" nzValue="active"></nz-option>
          <nz-option nzLabel="Inactive" nzValue="inactive"></nz-option>
        </nz-select>
      </div>
    </div> -->

    <!-- Target Module -->
    <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">Target Module</div>
        <nz-select
          class="width-100"
          nzAllowClear
          nzPlaceHolder="Select Module"
          [(ngModel)]="selectedModule"
          (ngModelChange)="onFilterChange()"
        >
          <nz-option
            nzLabel="Current Affair"
            nzValue="currentAffair"
          ></nz-option>
          <nz-option nzLabel="Editorial" nzValue="editorial"></nz-option>
          <nz-option nzLabel="Test Series" nzValue="testSery"></nz-option>
          <nz-option nzLabel="Plan" nzValue="plan"></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Date Range -->
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <!-- <nz-form-item> -->
      <div class="filter-label">Schedule Date Range</div>
      <nz-form-control [nzSpan]="24">
        <nz-range-picker
          class="width-100"
          [(ngModel)]="dateRange"
          (ngModelChange)="onChangeDateRange($event)"
        ></nz-range-picker>
      </nz-form-control>
      <!-- </nz-form-item> -->
    </div>

    <!-- Search -->
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">Search</div>
        <nz-input-group [nzPrefix]="searchIcon">
          <input
            nz-input
            placeholder="Search notifications..."
            [ngModel]="search"
            (ngModelChange)="searchNotifications($event)"
          />
        </nz-input-group>
        <ng-template #searchIcon>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- TABLE CARD -->
<div class="table-card">
  <nz-tabset
    (nzSelectedIndexChange)="changeIndex($event)"
    [nzSelectedIndex]="index"
  >
    <!-- ══════════ TAB 1: Approved ══════════ -->
    <nz-tab nzTitle="Approved Notifications">
      <nz-table
        #approvedTbl
        [nzData]="allApprovedNotifications"
        [nzLoading]="loading"
        [nzTotal]="totalApprovedDataCount"
        [(nzPageSize)]="pageSize"
        [nzPageIndex]="pageIndex"
        [nzFrontPagination]="false"
        nzShowSizeChanger
        (nzQueryParams)="onQueryParamsChange($event)"
      >
        <thead>
          <tr>
            <th nzWidth="220px">Notification</th>
            <th nzWidth="100px">Type</th>
            <th nzWidth="100px">Status</th>
            <th nzWidth="140px">Target Module</th>
            <th nzWidth="150px">Schedule Date</th>
            <th nzWidth="120px">Repeat Days</th>
            <th nzWidth="130px">Created By</th>
            <th nzWidth="120px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of approvedTbl.data">
            <!-- Notification Title + Description -->
            <td>
              <div class="notif-cell">
                <div class="notif-thumb" *ngIf="data.image">
                  <img [src]="imageBaseUrl + data.image" alt="thumb" />
                </div>
                <div class="notif-thumb-placeholder" *ngIf="!data.image">
                  🔔
                </div>
                <div>
                  <div class="notif-title">{{ data.title }}</div>
                  <div class="notif-desc">{{ data.description || "—" }}</div>
                </div>
              </div>
            </td>

            <!-- Type -->
            <td>
              <span class="tag" [ngClass]="getTypeClass(data.type)">
                {{ data.type | titlecase }}
              </span>
            </td>

            <!-- Status -->
            <td>
              <span class="tag" [ngClass]="getStatusClass(data.status)">
                {{ data.status ? "✔ Active" : "✖ Inactive" }}
              </span>
            </td>

            <!-- Target Module -->
            <td>
              <span
                *ngIf="data.targetModule"
                class="tag"
                [ngClass]="getModuleClass(data.targetModule)"
              >
                {{ getModuleLabel(data.targetModule) }}
              </span>
              <span *ngIf="!data.targetModule" class="text-muted">—</span>
            </td>

            <!-- Schedule Date -->
            <td>
              <div class="date-primary">
                {{ data.scheduleDate | date: "dd MMM yyyy" }}
              </div>
              <div class="date-secondary">
                {{ data.scheduleDate | date: "HH:mm:ss" }}
              </div>
            </td>

            <!-- Repeat Days -->
            <td class="text-center">
              <span class="repeat-badge" *ngIf="data.repeatDays > 0">
                🔁 {{ data.repeatDays }}d
              </span>
              <span class="text-muted" *ngIf="!data.repeatDays">No repeat</span>
            </td>

            <!-- Created By -->
            <td>
              <div class="user-cell">
                <div class="avatar">
                  {{ (data.createdBy?.name || "A")[0] }}
                </div>
                <span class="user-name">{{
                  data.createdBy?.name || "Admin"
                }}</span>
              </div>
            </td>

            <!-- Actions -->
            <td class="action-buttons">
              <a
                nz-button
                nzTooltipTitle="View"
                nzTooltipPlacement="topCenter"
                nz-tooltip
                (click)="openDetails(data)"
                ><i nz-icon nzType="eye" nzTheme="outline"></i
              ></a>
              <a
                nz-button
                nzTooltipTitle="Edit"
                nzTooltipPlacement="topCenter"
                nz-tooltip
                [routerLink]="['update', data._id]"
                [queryParams]="{ index: index }"
                routerLinkActive="router-link-active"
                ><i nz-icon nzType="form" nzTheme="outline"></i
              ></a>
              <a
                *ngIf="userRole !== 'subAdmin'"
                class="action-button"
                nz-button
                nz-popconfirm
                nzPopconfirmTitle="Are you sure {{
                  data.status ? 'deActive' : 'active'
                }} this notification?"
                (nzOnConfirm)="updateStatus(data._id, data.status)"
                nzTooltipTitle="{{ data.status ? 'Deactive' : 'Active' }}"
                nzTooltipPlacement="topRight"
                nz-tooltip
                ><i
                  nz-icon
                  [nzType]="data.status ? 'stop' : 'check'"
                  nzTheme="outline"
                ></i
              ></a>
              <a
                *ngIf="userRole === 'admin'"
                class="action-button delete"
                nz-button
                nzDanger
                (click)="confirmDelete(data._id)"
                nzTooltipTitle="Delete"
                nzTooltipPlacement="topRight"
                nz-tooltip
                ><i nz-icon nzType="delete" nzTheme="outline"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>

    <!-- ══════════ TAB 2: Un-approved ══════════ -->
    <nz-tab nzTitle="Un-approved Notifications">
      <nz-table
        #unapprovedTbl
        [nzData]="allNotifications"
        [nzLoading]="loading"
        [nzTotal]="totalDataCount"
        [(nzPageSize)]="pageSize"
        [nzPageIndex]="pageIndex"
        [nzFrontPagination]="false"
        nzShowSizeChanger
        (nzQueryParams)="onQueryParamsChange($event)"
      >
        <thead>
          <tr>
            <th nzWidth="220px">Notification</th>
            <th nzWidth="100px">Type</th>
            <th nzWidth="140px">Target Module</th>
            <th nzWidth="150px">Schedule Date</th>
            <th nzWidth="130px">Created By</th>
            <th nzWidth="150px">Rejected Reason</th>
            <th nzWidth="110px">Approve Status</th>
            <th nzWidth="160px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of unapprovedTbl.data">
            <!-- Notification Title + Description -->
            <td>
              <div class="notif-cell">
                <div class="notif-thumb" *ngIf="data.image">
                  <img [src]="imageBaseUrl + data.image" alt="thumb" />
                </div>
                <div class="notif-thumb-placeholder" *ngIf="!data.image">
                  🔔
                </div>
                <div>
                  <div class="notif-title">{{ data.title }}</div>
                  <div class="notif-desc">{{ data.description || "—" }}</div>
                </div>
              </div>
            </td>

            <!-- Type -->
            <td>
              <span class="tag" [ngClass]="getTypeClass(data.type)">
                {{ data.type | titlecase }}
              </span>
            </td>

            <!-- Target Module -->
            <td>
              <span
                *ngIf="data.targetModule"
                class="tag"
                [ngClass]="getModuleClass(data.targetModule)"
              >
                {{ getModuleLabel(data.targetModule) }}
              </span>
              <span *ngIf="!data.targetModule" class="text-muted">—</span>
            </td>

            <!-- Schedule Date -->
            <td>
              <div class="date-primary">
                {{ data.scheduleDate | date: "dd MMM yyyy" }}
              </div>
              <div class="date-secondary">
                {{ data.scheduleDate | date: "HH:mm:ss" }}
              </div>
            </td>

            <!-- Created By -->
            <td>
              <div class="user-cell">
                <div class="avatar">
                  {{ (data.createdBy?.name || "A")[0] }}
                </div>
                <span class="user-name">{{
                  data.createdBy?.name || "Admin"
                }}</span>
              </div>
            </td>

            <!-- Rejection Reason -->
            <td>
              <span *ngIf="data.rejectionReason" class="ellipsis">{{
                data.rejectionReason
              }}</span>
            </td>

            <!-- Approve Status -->
            <td>
              <nz-tag
                [nzColor]="
                  data.approveStatus === 'approved'
                    ? 'green'
                    : data.approveStatus === 'pending'
                      ? 'lime'
                      : 'volcano'
                "
              >
                {{ data.approveStatus }}
              </nz-tag>
            </td>

            <!-- Actions -->
            <td class="action-buttons">
              <a
                nz-button
                nzTooltipTitle="View"
                nzTooltipPlacement="topCenter"
                nz-tooltip
                (click)="openDetails(data)"
                ><i nz-icon nzType="eye" nzTheme="outline"></i
              ></a>
              <a
                nz-button
                nzTooltipTitle="Edit"
                nzTooltipPlacement="topCenter"
                nz-tooltip
                [routerLink]="['update', data._id]"
                [queryParams]="{ index: index }"
                routerLinkActive="router-link-active"
                ><i nz-icon nzType="form" nzTheme="outline"></i
              ></a>
              <!-- Active/Inactive -->
              <a
                *ngIf="userRole !== 'subAdmin'"
                class="action-button"
                nz-button
                nz-popconfirm
                nzPopconfirmTitle="Are you sure {{
                  data.status ? 'deActive' : 'active'
                }} this notification?"
                (nzOnConfirm)="updateStatus(data._id, data.status)"
                nzTooltipTitle="{{ data.status ? 'Deactive' : 'Active' }}"
                nzTooltipPlacement="topRight"
                nz-tooltip
                ><i
                  nz-icon
                  [nzType]="data.status ? 'stop' : 'check'"
                  nzTheme="outline"
                ></i
              ></a>
              <!-- Approve -->
              <a
                *ngIf="userRole !== 'subAdmin'"
                class="action-button top-margin"
                nz-button
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to approve this notification?"
                (nzOnConfirm)="updateApproveStatus(data._id, 'approved')"
                nzTooltipTitle="Approve"
                nzTooltipPlacement="topRight"
                nz-tooltip
                ><i nz-icon nzType="file-done" nzTheme="outline"></i
              ></a>
              <!-- Reject -->
              <a
                *ngIf="
                  userRole !== 'subAdmin' && data.approveStatus !== 'rejected'
                "
                class="action-button top-margin delete"
                nz-button
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to reject this notification?"
                (nzOnConfirm)="openRejectionReason(data._id)"
                nzTooltipTitle="Reject"
                nzTooltipPlacement="topRight"
                nz-tooltip
                ><i nz-icon nzType="close-circle" nzTheme="fill"></i
              ></a>
              <!-- Delete -->
              <a
                *ngIf="userRole === 'admin'"
                class="action-button delete"
                nz-button
                nzDanger
                (click)="confirmDelete(data._id)"
                nzTooltipTitle="Delete"
                nzTooltipPlacement="topRight"
                nz-tooltip
                ><i nz-icon nzType="delete" nzTheme="outline"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>
  </nz-tabset>
</div>
